import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { ReportsService } from '../../../services/reports/reports.service';
import { ReportLevelService } from '../../../services/reports/report-level.service';
import { BaseComponent } from '../../base/base.component';
import { DragDropFieldsComponent } from './drag-drop-fields.component';
import { DualListFieldsComponent } from './dual-list-fields.component';

@Component({
  selector: 'app-report-fields',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DragDropFieldsComponent, DualListFieldsComponent],
  template: `
    @if (useDualList()) {
      <app-dual-list-fields [report]="reports.currentReport()" />
    } @else {
      <app-drag-drop-fields [report]="reports.currentReport()" />
    }
  `,
})
export class ReportFieldsComponent extends BaseComponent implements OnInit {
  // Services
  reports = inject(ReportsService);
  private reportLevelService = inject(ReportLevelService);

  @ViewChild(DualListFieldsComponent) dualListFields: DualListFieldsComponent;

  useDualList = signal(false);

  get invalid(): boolean {
    if (this.useDualList()) {
      return this.dualListFields?.invalid() ?? false;
    }
    return false;
  }

  ngOnInit(): void {
    const report = this.reports.currentReport();
    const reportId = report.reportTemplate?.id;

    // Use dual-list mode if report has UDF or is an Ad-Hoc report (Payment/Reserve)
    const udfMultiselect = report.reportSections?.udfMultiselect ?? false;
    const isAdHocPayment = reportId
      ? this.reportLevelService.isAdHocPaymentReport(reportId)
      : false;
    const isAdHocReserve = reportId
      ? this.reportLevelService.isAdHocReserveReport(reportId)
      : false;
    const isAdHocClaim = reportId
      ? this.reportLevelService.isAdHocClaimReport(reportId)
      : false;
    const shouldUseDualList =
      udfMultiselect || isAdHocPayment || isAdHocReserve || isAdHocClaim;

    this.useDualList.set(shouldUseDualList);
  }
}
